export default {
  nav: {
    findBarber: 'Намери бръснар'
  },
  navigation: {
    home: 'Начало',
    aboutUs: 'За нас',
    contactUs: 'Контакти',
    demo: 'Демо',
    login: 'Вход',
    language: 'Език',
    logo: 'Лого',
    toggleMenu: 'Отвори/затвори меню',
    changeLanguage: 'Смяна на езика',
    scrollToTop: 'Нагоре',
    joinAsBarber: 'Присъедини се като бръснар',
    pricing: 'Цени',
    signUp: 'Регистрация'
  },
  home: {
    hero: {
      eyebrow: 'Сега приемаме в София - остават 3 места тази седмица',
      mainTitle: 'Твоят стол.<br>Твоят график.<br><span class="hero-title-accent">Твоят растеж.</span>',
      mainDesc: "Прекарал си години в усъвършенстване на занаята си. Не трябва да губиш вечерите си в отговаряне на съобщения. Barbers Unity ти дава професионална страница за резервации и пълен календар - за да се фокусираш върху подстригването, а не върху преследването на клиенти.",
      growBusiness: 'Искам повече клиенти',
      seeDashboard: 'Виж таблото',
      trustText: '<strong>Петър Барбов</strong> и бръснари от цяла Европа вече са на платформата.',
      joinThem: 'Присъедини се към тях →'
    },
    pain: {
      label: 'Звучи ли ти познато?',
      answer: 'Barbers Unity решава всичко това.',
      items: [
        'Клиентите звънят, докато си по средата на подстригване',
        'Неявявания, които ти губят най-добрите часове',
        'Забравяш да потвърдиш резервациите в WhatsApp',
        'Дублирани резервации, които те поставят в неудобно положение',
        'Водене на хартиен график през 2025 г.'
      ]
    },
    mobile: {
      label: 'Управление от джоба',
      title: 'Управлявай салона си отвсякъде.',
      desc: "Не седиш зад бюро. Barbers Unity е напълно оптимизиран за твоя мобилен телефон. Проверявай графика си, приемай резервации и преглеждай историята на клиентите между подстригванията.",
      list: [
        'Незабавни push известия за нови резервации',
        'Преглед на цялата история на клиента с един поглед',
        'Въвеждане на клиенти без час в календара за 3 секунди'
      ]
    },
    featuresList: [
      { title: 'Твоя собствена страница за резервации', desc: 'Професионален линк, който споделяш навсякъде - Instagram bio, WhatsApp, Google. Клиентите се записват сами, 24/7.' },
      { title: 'Умен календар', desc: 'Прегледай цялата седмица с един поглед. Блокирай лично време, задай работно време, никога повече не допускай дублирани резервации.' },
      { title: 'База с клиенти', desc: "История и контакти на всеки клиент - организирани и с възможност за търсене, винаги под ръка." },
      { title: 'Мултинационална платформа', desc: 'Изградена за бръснари в цяла Европа. Поддържа EN, BG, HR, ALB, GER и продължава да расте.' }
    ],
    calendar_preview: {
      title: 'Твоят календар, на всяко устройство.'
    },
    how: {
      label: 'Как да започнеш',
      title: 'Готов си за работа за по-малко от 10 минути'
    },
    stepsList: [
      { title: 'Създай профил' },
      { title: 'Сподели линка си' },
      { title: 'Фокусирай се върху занаята' }
    ],
    testimonial: {
      quote: "Преди Barbers Unity губех по 3-4 резервации седмично само от пропуснати обаждания и съобщения в WhatsApp, на които забравях да отговоря. При 20 € на подстригване, това са 240-320 €, които губех всеки месец. Сега календарът ми се пълни сам. Просто се появявам и подстригвам.",
      name: 'Петър Барбов',
      role: 'Професионален бръснар · Ранен член'
    },
    stats: {
      label: 'Активност в платформата',
      title: 'Реални цифри, които растат всеки ден',
      bookings: 'Управлявани резервации',
      clients: 'Обслужени клиенти',
      time: 'Спестено време на бръснар / седмица'
    },
    pricing: {
      label: 'Справедливо ценообразуване',
      title: 'Не плащай комисионни за собствения си успех',
      desc: 'Другите платформи те наказват, когато имаш повече работа, като те таксуват на резервация. Ние вярваме, че това, което изработиш, трябва да остане за теб.',
      competitorNote: 'След като конкурентен бръснар в твоя град заеме своето място, той получава предимство. Първият бръснар за район получава приоритетно позициониране при търсене от клиенти.',
      identityLine: 'Изградено за бръснари, които се отнасят към това като към бизнес, а не като към хоби.',
      them: {
        label: 'Конкуренти',
        list: [ 'Таксуват на резервация', 'Скрити такси и неочаквани разходи', 'Таксите растат с увеличаването на работата' ],
        price: 'До 200 €',
        sub: '/мес'
      },
      vs: 'СРЕЩУ',
      us: {
        label: 'Barbers Unity',
        list: [ 'Неограничени резервации', 'Без комисионни, без скрити такси', 'Запази 100% от приходите си' ],
        price: '35 €',
        sub: '/мес фиксирано'
      }
    },
    calc: {
      label: 'Калкулатор на приходите',
      title: "Виж какво губиш",
      desc: 'Всяка пропусната резервация е загубени пари. Нагласи плъзгачите, за да видиш колко повече можеш да изкарваш всеки месец.',
      button: 'Започни да печелиш повече',
      cuts: 'Подстригвания на ден',
      price: 'Цена на подстригване (€)',
      missed: 'Пропуснати резервации седмично',
      monthlyNow: 'Месечно сега',
      withUs: 'С Barbers Unity',
      recovered: '/ възстановени на месец',
      lossThisMonth: 'вече загубени този месец'
    },
    faq: {
      label: 'Имаш въпроси?',
      title: 'Често Задавани Въпроси'
    },
    faqList: [
      { q: "Трябва ли клиентите ми да изтеглят приложение?", a: "Не! Твоите клиенти се записват чрез чист и бърз уеб линк директно в своя браузър. Без изтегляне на приложения, без нужда от създаване на акаунт, без никакви пречки за тях." },
      { q: "Как получавам парите си?", a: "Задържаш 100% от това, което изкараш. Клиентите ти плащат директно в салона, както винаги. Ние не взимаме дял или комисионна от твоите подстригвания." },
      { q: "Обвързан ли съм с договор?", a: "Абсолютно не. Barbers Unity е с фиксиран месечен абонамент. Можеш да анулираш по всяко време." },
      { q: "Вече използвам друга система. Трудно ли е да премина?", a: "Изисква 0 усилия. Изпрати ни текущия си списък с клиенти, а ние ще импортираме всичко и ще настроим профила ти напълно безплатно." }
    ],
    upcoming: {
      label: 'Скоро',
      title: 'Идват още по-мощни инструменти',
      badge: 'Скоро'
    },
    cta: {
      title: 'Готов ли си да запълниш календара си?',
      button: 'Започни сега'
    },
    pricingCta: {
      title: 'Готов ли си да развиеш салона си?',
      subtitle: '35 €/мес · Първи месец безплатно',
      button: 'Започни сега'
    }
  },
  about: {
    title: 'За Barbers Unity',
    description: "Ние революционизираме начина, по който бръснарите се свързват с клиентите си. Нашата платформа дава възможност на бръснарите да показват работата си, да управляват графика си и да развиват бизнеса си ефективно.",
    founded: 'Основана през 2025 г., Barbers Unity прерасна от проста идея в цялостна платформа, обслужваща бръснари в много страни.',
    ourStory: 'Нашата история',
    whatDrivesUs: 'Какво ни движи',
    mission: {
      title: 'Нашата мисия',
      description: 'Да опростим и модернизираме процеса на резервации за бръснарите'
    },
    vision: {
      title: 'Нашата визия',
      description: 'Създаване на най-голямата общност от свързани бръснари по целия свят'
    },
    values: {
      title: 'Нашите ценности',
      description: 'Качество, доверие и професионален растеж'
    },
    built: {
      label: 'Изградено за професията',
      title: 'Ние разбираме този стол.',
      desc1: "Barbers Unity не е създадена в някаква заседателна зала. Създадена е, защото видяхме как страхотни бръснари - талантливи, заети, уважавани - губят клиенти заради пропуснати обаждания и лоши системи за резервации, които не бяха направени за тях.",
      desc2: 'Създадохме платформата, която липсваше на пазара: такава, която приема занаята ти сериозно, поставя твоята марка на първо място и поема администрацията, за да не се налага никога повече да мислиш за нея.',
      stats: {
        countries: 'Държави, които покриваме',
        time: 'Време за активиране',
        cost: 'Цена за настройка'
      }
    },
    testimonial: {
      quote: "Преди Barbers Unity губех по 3-4 резервации седмично само от пропуснати обаждания и съобщения в WhatsApp, на които забравях да отговоря. При 20 € на подстригване, това са 240-320 €, които губех всеки месец. Сега календарът ми се пълни сам. Просто се появявам и подстригвам.",
      name: 'Петър Барбов',
      role: 'Професионален бръснар · Ранен член'
    },
    timeline: {
      label: 'Времева линия',
      title: 'Градим нещо по-голямо.',
      items: [
        { year: '2025', event: 'Основаване на Barbers Unity - родено от разочарованието от заетите телефонни линии и пропуснатите часове.' },
        { year: '2025', event: 'Платформата е пусната в бета версия.' },
        { year: 'Сега', event: 'Разширяване на мрежата - повече бръснари, повече градове, по-добри инструменти за всички.' }
      ]
    },
    cta: {
      eyebrow: 'Ограничени места за регистрация - резервирай, преди да се запълнят',
      title: 'Искаш ли да бъдеш част от историята?',
      description: "Независимо дали си бръснар или клиент, за теб има място в общността на Barbers Unity.",
      findBarber: 'Намери бръснар',
      getInTouch: 'Свържи се с нас'
    }
  },
  contact: {
    title: 'Контакти',
    getInTouch: {
      title: 'Свържи се с нас',
      description: 'Имаш въпроси относно Barbers Unity? Тук сме, за да помогнем! Свържи се с нас чрез някой от социалните ни канали или ни изпрати съобщение директно.',
      info: "Имаш въпроси относно Barbers Unity? Тук сме, за да помогнем - пиши ни чрез някой от каналите по-долу."
    },
    followUs: 'Последвай ни',
    b2b: {
      text: "<strong>Ти си бръснар?</strong> Пропусни формата - резервирай безплатен 20-минутен разговор и ще настроим всичко заедно.",
      button: 'Резервирай безплатен разговор'
    },
    success: {
      title: 'Съобщението е изпратено!',
      desc: "Благодарим ти, че се свърза с нас. Ще ти отговорим възможно най-скоро.",
      button: 'Изпрати ново'
    },
    form: {
      name: 'Име',
      namePlaceholder: 'Твоето име',
      email: 'Имейл',
      emailPlaceholder: 'tvoyat@email.com',
      message: 'Съобщение',
      messagePlaceholder: 'Кажи ни как можем да помогнем...',
      send: 'Изпрати съобщение'
    }
  },
  forBusiness: {
    hero: {
      eyebrow: 'Ограничени места - сега приемаме бръснари',
      mainTitle: 'Спри да управляваш бизнеса си<br><span class="title-accent">ръчно.</span>',
      mainDesc: 'Всяко пропуснато обаждане са загубени пари. Всяко неявяване хаби първокласен час. Barbers Unity ти дава професионална система, която държи календара ти пълен, а клиентите ти информирани.',
      bookCall: 'Резервирай безплатен разговор за настройка',
      seeDashboard: 'Виж таблото',
      trust: ['Безплатна настройка', 'Без договори', 'Готов за работа за 10 минути']
    },
    loss: {
      beforeLabel: 'Без Barbers Unity',
      afterLabel: 'С Barbers Unity',
      without: [
        'Пропускаш обаждания, докато подстригваш',
        'Неявявания, които ти губят цели часове',
        'Ръчно потвърждаване на всяка резервация',
        'Хартиен тефтер или разхвърляни таблици',
        'Нямаш представа кои услуги ти носят най-много пари'
      ],
      with: [
        'Клиентите се записват сами онлайн, 24/7',
        'Календарът се актуализира мигновено, нула усилия',
        'Професионално табло, винаги организирано',
        'Пълна история на резервациите и преглед на услугите',
        'Работи в различни държави и на няколко езика'
      ]
    },
    features: {
      label: 'Какво получаваш',
      heading: 'Всичко, от което се нуждае един професионален бръснар',
      items: [
        { title: 'Твоя професионална страница за резервации', desc: 'Чист, брандиран линк, който споделяш навсякъде - Instagram bio, WhatsApp, Google. Клиентите виждат услугите ти, цените, свободните часове и сами резервират. Без телефонни обаждания, без разправии.', badge: 'Готово за няколко минути' },
        { title: 'Пълен календар, изграден за бръснари', desc: 'Блокирай лично време, задай работно време, управлявай няколко услуги с различна продължителност. Прегледай цялата седмица с един поглед и никога не допускай дублирани резервации.', badge: null },
        { title: 'История и предпочитания на клиента', desc: "История на подстригванията на всеки клиент, контакти и бележки - организирани и с възможност за търсене. Знай точно какво иска всеки клиент, преди да е седнал на стола ти.", badge: null },
        { title: 'Автоматични напомняния (скоро)', desc: 'Email и WhatsApp напомняния автоматично ще се изпращат преди всеки час. Неявяванията ще станат част от миналото. Очаквайте скоро.', badge: 'Скоро' }
      ]
    },
    why: {
      label: 'Защо бръснарите избират нас',
      heading: 'Твоят стол.<br>Твоите правила.<br>Твоят приход.',
      body: 'Barbers Unity поставя бизнеса ти пред клиенти, които активно търсят - с нула студени обаждания, нула преследване на клиенти и нула догадки.',
      list: [
        'Нула студени обаждания - клиентите идват при теб',
        'Настройка в един 20-минутен разговор, напълно безплатно',
        'Работи със съществуващите ти WhatsApp и имейл',
        "Без договори - тръгваш си, когато пожелаеш (но няма да искаш)",
        'Специализирана поддръжка, а не чатбот'
      ],
      highlights: [
        { title: 'Незабавна настройка', desc: "20 минути разговор. Активен си, преди да затвориш." },
        { title: 'Изградено за бръснари', desc: 'Проектирано заедно с бръснари - не просто около тях.' },
        { title: 'Много езици', desc: 'EN, BG, HR, ALB, GER - където и да работиш.' },
        { title: 'Без договор', desc: 'Започни безплатно. Остани, защото работи, а не защото си обвързан.' }
      ]
    },
    testimonial: {
      quote: "Преди Barbers Unity губех по 3-4 резервации седмично само от пропуснати обаждания и съобщения в WhatsApp, на които забравях да отговоря. При 20 € на подстригване, това са 240-320 €, които губех всеки месец. Сега календарът ми се пълни сам. Просто се появявам и подстригвам.",
      name: 'Петър Барбов',
      role: 'Професионален бръснар · Ранен член'
    },
    cta: {
      eyebrow: 'Сега приемаме в София - остават 3 места тази седмица',
      mainTitle: 'Готов ли си за изцяло резервиран бизнес?',
      sub: "Резервирай безплатен 20-минутен разговор за настройка. Ще настроим всичко заедно - твоя профил, услуги и календар. Ще бъдеш готов за работа преди разговорът да приключи.",
      bookCall: 'Резервирай моя безплатен разговор',
      member: 'Вече си член?',
      login: 'Влез в таблото →'
    }
  },
  footer: {
    description: 'Свързваме бръснари с клиенти, опростяваме резервациите и развиваме бизнеса.',
    quickLinks: {
      title: 'Бързи връзки',
      about: 'За нас',
      contact: 'Контакти',
      demo: 'Демо'
    },
    legal: {
      title: 'Правна информация',
      privacy: 'Политика за поверителност',
      terms: 'Условия за ползване'
    },
    followUs: 'Последвай ни',
    social: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      tiktok: 'TikTok'
    },
    copyright: '© 2025 BarbersUnity. Всички права запазени.'
  },
  tailwindMessage: "Tailwind CSS работи във Vue 3! 🎉",
  clickMe: "Натисни тук",
  previous: 'Назад',
  notFound: {
    title: 'Страницата не е намерена',
    description: "Страницата, която търсиш, не съществува или е преместена.",
    backHome: 'Връщане в началото'
  },
  cookies: {
    title: 'Настройки на бисквитките',
    message: 'Ние използваме бисквитки, за да подобрим твоето изживяване, да анализираме трафика и да показваме персонализирано съдържание. Продължавайки да използваш нашия сайт, ти се съгласяваш с използването на бисквитки.',
    decline: 'Откажи',
    accept: 'Приеми всички'
  },
  map: {
    eyebrow: 'Намери бръснар',
    heading: 'Бръснари близо до теб',
    searchPlaceholder: 'Търси по град или име...',
    loading: 'Зареждане на картата...',
    error: {
      title: 'Неуспешно зареждане на картата',
      desc: 'Възникна грешка при зареждането на картата. Моля, опитай отново.',
      retry: 'Опитай отново'
    },
    results: 'резултати',
    result: 'резултат',
    bookNow: 'Резервирай'
  },
  privacy: {
    intro: 'Добре дошъл в Barbers Unity. Ние уважаваме твоята поверителност и сме ангажирани със защитата на личните ти данни. Тази политика за поверителност ще те информира как се грижим за твоите лични данни, когато посещаваш нашия уебсайт, и ще ти разкаже за твоите права за поверителност и как законът те защитава.',
    sections: {
      collect: {
        title: '1. Информация, която събираме',
        desc: 'Може да събираме, използваме, съхраняваме и прехвърляме различни видове лични данни за теб, които сме групирали по следния начин:',
        items: [
          '<strong>Данните за самоличност</strong> включват първо име, фамилия, потребителско име или подобен идентификатор.',
          '<strong>Данните за контакт</strong> включват имейл адрес и телефонни номера.',
          '<strong>Техническите данни</strong> включват адрес на интернет протокол (IP), тип и версия на браузъра, настройка на часовата зона и други технологии на устройствата, които използваш за достъп до този уебсайт.'
        ]
      },
      use: {
        title: '2. Как използваме твоите данни',
        desc: 'Ще използваме твоите лични данни само когато законът ни го позволява. Най-често ще използваме личните ти данни при следните обстоятелства:',
        items: [
          'Когато трябва да изпълним договора, който предстои да сключим или вече сме сключили с теб (напр. резервация на час).',
          'Когато това е необходимо за нашите легитимни интереси, а твоите интереси и основни права не ги отменят.',
          'Когато трябва да спазим законови задължения.'
        ]
      },
      contact: {
        title: '3. Свържи се с нас',
        desc: 'Ако имаш въпроси относно тази политика за поверителност или нашите практики, моля, свържи се с нас чрез посочените канали за връзка.'
      }
    }
  },
  pricing: {
    title: 'Лесно ценообразуване',
    subtitle: 'Един план. Всичко включено. Първи месец безплатно.',
    price: '35',
    period: '/мес',
    trial: 'Първи месец БЕЗПЛАТНО',
    cta: 'Започни безплатен тест',
    features: [
      'Неограничени резервации',
      'Известия за клиенти',
      'QR код и генератор на истории',
      'Календар за няколко служители',
      'Аналитично табло',
      'Приоритетна поддръжка'
    ]
  },
  terms: {
    title: 'Условия за ползване',
    intro: 'Добре дошли в Barbers Unity. Използвайки нашата платформа, вие се съгласявате с тези условия. Моля, прочетете ги внимателно.',
    sections: {
      account: {
        title: '1. Регистрация на акаунт',
        desc: 'Трябва да предоставите точна информация при създаване на акаунт. Вие носите отговорност за запазването на сигурността на вашите данни за вход.'
      },
      usage: {
        title: '2. Допустима употреба',
        desc: 'Съгласявате се да не злоупотребявате с платформата, да не пречите на нормалната ѝ работа и да не се опитвате да получите достъп до нея по метод, различен от интерфейса, който предоставяме.'
      },
      fees: {
        title: '3. Абонамент и такси',
        desc: 'Нашите услуги се таксуват на абонаментен принцип. Всички такси са невъзвръщаеми, освен ако законът не изисква друго.'
      },
      liability: {
        title: '4. Ограничаване на отговорността',
        desc: 'Barbers Unity се предоставя "както е". Ние не носим отговорност за никакви косвени, случайни или последващи щети, произтичащи от използването на платформата.'
      }
    }
  },
  loading: {
    title: 'Зареждане...',
    message: 'Моля, изчакайте'
  },
  modal: {
    registerTitle: 'Изберете тип акаунт',
    businessTitle: 'Регистрация като бизнес',
    businessDesc: 'Салон / Бръснар',
    customerTitle: 'Регистрация като клиент',
    customerDesc: 'Запазване на часове'
  }
}